import { Btn, Card } from "../../utils/ui.jsx";

export function UserAdminTabsBar({
  // Which section tabs this instance shows (5 July 2026 Manage split; the
  // Caseworkers tab was RETIRED in Phase 3 — caseworkers live on the shelter
  // detail's Users tab). Both current screens are single-section (Shelters /
  // Zephyr Staff), which hides the pill row entirely.
  sections = ["shelters", "staff"],
  shelters,
  staffRows,
  activeSection,
  setActiveSection,
  setEditing,
  setViewing,
  search,
  setSearch,
  setShowNew,
}) {
  const allTabs = [
    ["shelters", `DFV Services (${shelters.length})`],
    ["staff", `Zephyr Staff (${staffRows.length})`],
  ];
  const tabs = allTabs.filter(function (pair) {
    return sections.includes(pair[0]);
  });
  return (
    <Card style={{ marginBottom: 16, padding: 14 }}>
      {tabs.length > 1 && (
        <div className="flex gap-[6px] mb-3">
          {tabs.map(function (pair) {
            var key = pair[0];
            var label = pair[1];
            return (
              <button
                key={key}
                onClick={function () {
                  setActiveSection(key);
                  setEditing(null);
                  setViewing(null);
                  setSearch("");
                }}
                className={[
                  "py-[7px] px-[18px] rounded-[20px] text-[13px] font-semibold cursor-pointer border",
                  activeSection === key
                    ? "bg-zephyr-teal-dark text-white border-zephyr-teal-dark"
                    : "bg-white text-zephyr-text border-zephyr-border",
                ].join(" ")}
                style={{ fontFamily: "inherit" }}
              >
                {label}
              </button>
            );
          })}
        </div>
      )}
      <div className="flex gap-[10px] items-center">
        <input
          placeholder={
            activeSection === "shelters"
              ? "Search DFV Service name, code — or an attached user's name/email..."
              : "Search name, email, role..."
          }
          value={search}
          onChange={function (e) {
            setSearch(e.target.value);
          }}
          className="flex-1 min-w-[200px] py-2 px-3 rounded-[8px] border border-zephyr-border text-[13px]"
          style={{ fontFamily: "inherit" }}
        />
        {search && (
          <Btn
            variant="secondary"
            onClick={function () {
              setSearch("");
            }}
          >
            Clear
          </Btn>
        )}
        <Btn
          onClick={function () {
            setShowNew(true);
          }}
        >
          {activeSection === "shelters" ? "+ New DFV Service" : "+ New Staff"}
        </Btn>
      </div>
    </Card>
  );
}
